<template lang="html">
    <div class="category-tree__node">
        <div
                class="category-tree__row"
                :class="{'category-tree__row--child': depth > 0}"
        >
            <div class="category-tree__cell category-tree__cell--handle category-tree__drag-handle">
                <v-icon>drag_indicator</v-icon>
            </div>
            <div class="category-tree__cell">{{ category.id }}</div>
            <div class="category-tree__cell category-tree__cell--grow">
                <router-link :to="{name: 'CategoriesDetail', params: {id: category.id}}">
                    {{ category.name }}
                </router-link>
            </div>
            <div class="category-tree__cell category-tree__cell--grow">{{ category.slug }}</div>
            <div class="category-tree__cell small bold">
                <span v-if="category.published" class="published">ANO</span>
                <span v-else class="published published--not">NE</span>
            </div>
            <div class="category-tree__cell small bold">
                <span class="seo seo--checked" v-if="category.seo">
                    <v-icon>check</v-icon>
                </span>
                <span class="seo" v-else></span>
            </div>
            <div class="category-tree__cell right">
                <router-link :to="{name: 'CategoriesDetail', params: {id: category.id}}">
                    <v-btn color="primary" type="submit" class="button--small">Detail</v-btn>
                </router-link>
            </div>
        </div>

        <draggable
                v-if="depth === 0"
                v-model="category.children"
                tag="div"
                group="categories"
                handle=".category-tree__drag-handle"
                chosen-class="category-tree__node--dragging"
                class="category-tree__children"
                @end="$emit('end')"
        >
            <category-tree-node
                    v-for="child in category.children"
                    :key="child.id"
                    :category="child"
                    :depth="depth + 1"
                    @end="$emit('end')"
            />
        </draggable>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        name: 'CategoryTreeNode',
        components: {
            draggable
        },
        props: {
            category: {
                type: Object,
                required: true
            },
            depth: {
                type: Number,
                required: true
            }
        }
    }
</script>
